import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export interface ChatTemplate {
  id: string;
  name: string;
  description: string;
  model_id: string | null;
  /** Tool picker selection (server ids); null = the default tools. */
  mcp_servers: string[] | null;
  system_prompt: string | null;
  first_message: string | null;
  /** New chats from it start as temporary chats. */
  temporary: boolean;
  folder_id: string | null;
  /** Made by an admin for everyone. */
  is_global: boolean;
  editable: boolean;
  created_at: string;
}

export type TemplateInput = Omit<ChatTemplate, "id" | "editable" | "created_at">;

export function useTemplates() {
  return useQuery({ queryKey: ["templates"], queryFn: () => api.get<ChatTemplate[]>("/api/templates"), staleTime: 30_000 });
}
